import { FC } from 'react';

export interface HeadlineFromCraftProps {
  primarySansSerif: string;
  secondarySerif?: string;
}

const formHeadline = (headlineElements: HeadlineFromCraftProps): React.ReactNode => {
  if (headlineElements.secondarySerif) {
    return <span>{headlineElements.primarySansSerif} <span className="font-serif">{headlineElements.secondarySerif}</span></span>
  }

  return <span>{headlineElements.primarySansSerif}</span>;
};


const SerifAndSansSerifHeadline: FC<HeadlineFromCraftProps> = (props: HeadlineFromCraftProps) => {
  return formHeadline(props);
};

export default SerifAndSansSerifHeadline;
